// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import type { Category } from 'api/cms';
import { fetchSubsiteCategories } from '../redux/staff/actions/cmsDashboard/categories';

type OwnProps = {|
  locale: string,
  render: ({ categories: ?Array<Category> }) => React.Node,
  subsiteId: string
|};

type Props = {|
  ...$Exact<OwnProps>,
  categories: Array<Category>,
  fetchSubsiteCategories: Function
|};

class CategoriesContainer extends React.PureComponent<Props> {
  componentDidMount() {
    if (
      !this.props.categories ||
      (this.props.categories && this.props.categories.length <= 0)
    ) {
      this.props.fetchSubsiteCategories(this.props.subsiteId);
    }
  }

  render() {
    const { categories, locale } = this.props;
    const localizedCategories =
      categories && categories.filter(category => category.locale === locale);
    return this.props.render({ categories: localizedCategories || categories });
  }
}

const mapStateToProps = (
  {
    cmsDashboard: {
      categories: { bySubsiteId, byId: categoriesById }
    }
  },
  { subsiteId }
) => {
  const categories = bySubsiteId[subsiteId];
  return {
    categories:
      categories === undefined || categories.isFetching
        ? []
        : categories.categoryIds.map(categoryId => {
            const category = categoriesById[categoryId];
            if (category && category.childrenIds) {
              category.children = category.childrenIds.map(
                childId => categoriesById[childId]
              );
            }
            return category;
          })
  };
};

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { fetchSubsiteCategories }
)(CategoriesContainer);
